import { Link } from "react-router-dom";
import { ArrowLeft, FlaskConical } from "lucide-react";
import VideoJualan from "@/pages/VideoJualan";

// Admin smoke test = the EXACT same Video Jualan workflow (same lifecycle,
// credit gate, KIE engine, storage, settlement). No bypass, no second engine.
// Runs under the admin's own account/credits.
export default function AdminTestVideo() {
  return (
    <div className="min-h-screen bg-slate-100" data-testid="admin-test-video-page">
      <div className="flex items-center gap-3 border-b border-slate-200 bg-slate-900 px-6 py-3 text-white">
        <Link to="/admin" data-testid="admin-back-btn" className="flex items-center gap-1 text-sm text-slate-300 hover:text-white">
          <ArrowLeft className="h-4 w-4" /> Dashboard
        </Link>
        <span className="flex items-center gap-2 font-semibold">
          <FlaskConical className="h-4 w-4 text-emerald-400" /> Test Video (Smoke Test Produksi)
        </span>
        <span className="ml-auto text-xs text-slate-400">Memakai kredit admin — tanpa bypass credit gate</span>
      </div>
      <VideoJualan />
    </div>
  );
}
